import { Exception, PermissionException } from "@byloth/core";

export class EmptyStatsException extends Exception
{
    public constructor()
    {
        super("");
    }
}

export class ProjectNotFoundException extends PermissionException { }
